<template functional>
  <div
    class="dataset-body-loading"
    v-bind="data.attrs"
    v-on="listeners"
    :class="[data.staticClass, props.class]"
  >
    <slot v-if="slots().default" />
    <span v-else>loading</span>
  </div>
</template>

<script>
export default {
  name: 'DatasetLoading',
  props: {
    active: { type: Boolean, default: () => true },
    colspan: { type: Number, default: () => 1 },
  },
}
</script>

<style lang="scss">
$datasetMinHeight: 210px;

.dataset-body-loading {
  min-height: $datasetMinHeight;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;

  position: absolute;
  z-index: 0;
  min-height: $datasetMinHeight;
  top: 10px;
  left: 0;
  right: 0;
}
</style>
